import React from 'react';

const GlyphTick = props => (
  <svg viewBox='0 0 100 100' {...props}>
  <path
     d="M 76.70 21.27 C 82.73 26.16 84.12 35.29 79.75 41.73 C 76.58 45.93 72.32 49.31 68.80 53.23 C 69.46 49.26 69.28 46.16 68.33 42.26 C 70.63 39.88 73.87 37.63 74.04 34.02 C 74.39 29.47 70.51 25.62 65.97 26.01 C 63.20 26.19 61.58 27.89 59.71 29.71 C 55.25 34.26 50.73 38.73 46.22 43.23 C 44.30 45.11 42.95 47.15 43.21 49.98 C 43.45 53.42 45.67 55.15 48.42 56.78 C 46.39 58.74 44.39 60.73 42.37 62.71 C 39.08 60.05 36.44 57.05 35.56 52.80 C 34.43 47.63 35.88 42.37 39.58 38.59 C 45.05 33.06 50.56 27.55 56.09 22.08 C 61.59 16.61 70.78 16.29 76.70 21.27 Z"
     fill="#c3c3ff"
     id="path2615" />
  <path
     d="M 58.17 36.86 C 61.39 39.14 63.90 42.13 64.90 46.02 C 66.44 51.62 64.66 57.50 60.48 61.47 C 54.94 66.92 49.55 72.54 43.94 77.91 C 38.20 83.11 28.97 82.94 23.33 77.68 C 17.61 72.55 16.62 63.42 21.23 57.23 C 24.41 53.28 28.43 50.02 31.81 46.21 C 31.16 50.19 31.30 53.20 32.31 57.11 C 30.66 58.80 28.76 60.46 27.48 62.45 C 25.62 65.74 26.70 70.09 29.83 72.18 C 32.84 74.18 36.68 73.83 39.26 71.31 C 44.51 66.20 49.64 60.96 54.82 55.80 C 57.22 53.50 58.16 50.29 56.84 47.14 C 55.95 44.89 54.10 43.98 52.23 42.66 C 54.23 40.75 56.14 38.74 58.17 36.86 Z"
     fill="#CCD4FF"
     id="path2617" />
  </svg>
)

export default GlyphTick;
